import React, { PureComponent } from "react";
import PT from "prop-types";
import * as S from "./index-styled";
import {
  AngleLeftIconWhite,
  AngleRightIconWhite,
  DenyIconWhite,
} from "_c/icon";
import Aside from "./aside";
import Slider from "./slider";
import { useScrollLock } from "@/hooks/useScrollLock";

const ScrollLock = () => {
  useScrollLock();
  return null;
};
class Viewer extends PureComponent {
  state = {
    activeSlide: null,
  };
  static propTypes = {
    onClose: PT.func,
    active: PT.number,
    slides: PT.array,
    favorites: PT.array,
    addFavorite: PT.func,
    removeFavorite: PT.func,
    user: PT.object,
    updatePortfolio: PT.func,
    updatePortfolioItem: PT.func,
    t: PT.func.isRequired,
  };
  keyboardListener = ({ key }) => {
    if (key === "ArrowLeft") {
      this.prev();
    } else if (key === "ArrowRight") {
      this.next();
    }
  };
  componentDidMount() {
    this.setState({
      activeSlide: this.props.active,
    });
    document.addEventListener("keyup", this.keyboardListener);
  }
  componentWillUnmount() {
    this.props.onClose();
    document.removeEventListener("keyup", this.keyboardListener);
  }
  next = () => {
    this.setState(({ activeSlide }) => ({
      activeSlide:
        activeSlide + 1 >= this.props.slides.length
          ? activeSlide
          : activeSlide + 1,
    }));
  };
  prev = () => {
    this.setState(({ activeSlide }) => ({
      activeSlide: Math.max(0, activeSlide - 1),
    }));
  };
  render() {
    const {
      slides,
      onClose,
      favorites,
      toggleLike,
      updatePortfolioItem,
      openShareModal,
      addComment,
      removeComment,
    } = this.props;
    const { activeSlide } = this.state;
    const slide = activeSlide !== null && slides[activeSlide];
    return (
      <>
        <ScrollLock />
        <S.CloseButton
          title={this.props.t("common:close")}
          onClick={() => onClose()}
        >
          <DenyIconWhite />
        </S.CloseButton>
        <S.CloseOverlay onClick={onClose} />
        <S.InnerWrap>
          <S.LeftNavButton disabled={activeSlide === 0} onClick={this.prev}>
            <AngleLeftIconWhite />
          </S.LeftNavButton>
          <S.MobileCloseButton onClick={() => onClose()}>
            {this.props.t("common:close")}
          </S.MobileCloseButton>
          <Slider
            next={this.next}
            prev={this.prev}
            initRef={this.initRef}
            slide={slide}
          />
          {slide && (
            <Aside
              t={this.props.t}
              authUserId={this.props.authUserId}
              addComment={addComment}
              removeComment={removeComment}
              shouldFetchSlide
              toggleLike={toggleLike}
              openShareModal={openShareModal}
              favorites={favorites}
              updateSlide={updatePortfolioItem}
              slide={slide}
            />
          )}
          <S.RightNavButton
            disabled={activeSlide === slides.length - 1}
            onClick={this.next}
          >
            <AngleRightIconWhite />
          </S.RightNavButton>
        </S.InnerWrap>
      </>
    );
  }
}
const Modal = (props) => (
  <S.Modal {...props}>
    <Viewer {...props} />
  </S.Modal>
);
export default Modal;
